module.exports = __webpack_public_path__ + "static/media/translations.1029.1ae90bf0.resx";